import React from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface StarIconProps extends IconWrapperProps {
  color?: string;
  fillPercent?: number;
}

const StarIcon = ({
  color = "currentColor",
  fillPercent = 100,
  ...rest
}: StarIconProps) => {
  const id = React.useId();
  return (
    <IconWrapper viewBox="0 0 16 16" {...rest}>
      <defs>
        <linearGradient id={id}>
          <stop offset="0%" stopColor={color} />
          <stop offset={`${fillPercent}%`} stopColor={color} data-testid="star-fill-percent" />
          <stop offset={`${fillPercent}%`} stopColor="transparent" />
          <stop offset="100%" stopColor="transparent" />
        </linearGradient>
      </defs>
      <path
        d="M8 1.61803L9.32058 5.68237L9.43284 6.02786H9.79611H14.0696L10.6123 8.53976L10.3184 8.75329L10.4306 9.09878L11.7512 13.1631L8.29389 10.6512L8 10.4377L7.70611 10.6512L4.24877 13.1631L5.56936 9.09878L5.68162 8.75329L5.38772 8.53976L1.93039 6.02786H6.20389H6.56716L6.67942 5.68237L8 1.61803Z"
        fill={`url(#${id})`}
        stroke={color}
      />
    </IconWrapper>
  );
};

export default StarIcon;
